import { app, authentication } from '@microsoft/teams-js';
import React from 'react';
import ApplicationSettingService from '../services/applicationSettingService';
import SessionService from '../services/sessionService';

class PlatformIdentityCallback extends React.Component {

    async componentDidMount() {
        try {
            const hashParts = window.location.hash.split('?');
            let region: string | null = null;
            
            if (hashParts.length > 1) {
                const hashParams = new URLSearchParams(hashParts[1]);
                region = hashParams.get('region');
                if (region) {
                    region = decodeURIComponent(region);
                }
            }
            
            const piTokenUrl = await ApplicationSettingService.getPITokenUrl(region);
            const tokenUrl = piTokenUrl ? `${piTokenUrl}token` : `${window.location.origin}/api/token`;
            
            const tokenResponse = await fetch(tokenUrl, {
                credentials: 'include'
            });
            
            if (tokenResponse.ok) {
                const tokenDetail = await tokenResponse.json();
                
                if (tokenDetail && tokenDetail.token) {
                    const userDetail = await SessionService.validatePlatformIdentityUser(tokenDetail.token, region);
                    
                    // Handle userNotFound and schemaRefreshRunning by returning error in result
                    if (userDetail.userNotFound) {
                        console.log('PlatformIdentityCallback - User not found, returning error result');
                        const errorResult = JSON.stringify({
                            success: false,
                            errorType: 'userNotFound',
                            errorMessage: 'User does not exist in the database.'
                        });
                        authentication.notifySuccess(errorResult);
                        return;
                    }
                    
                    if (userDetail.schemaRefreshRunning) {
                        console.log('PlatformIdentityCallback - Schema refresh running, returning error result');
                        const errorResult = JSON.stringify({
                            success: false,
                            errorType: 'schemaRefreshRunning',
                            errorMessage: 'Database schema refresh is in progress. Please try again in a few minutes.'
                        });
                        authentication.notifySuccess(errorResult);
                        return;
                    }
                    
                    // Success case - return user details
                    const completeUserDetail = {
                        success: true,
                        token: tokenDetail.token,
                        refreshToken: tokenDetail.refreshToken,
                        tcToken: userDetail.tcToken,
                        email: userDetail.email,
                        orgReference: userDetail.orgReference,
                        userId: userDetail.userId,
                        domainName: userDetail.domainName,
                        userNotFound: userDetail.userNotFound,
                        schemaRefreshRunning: userDetail.schemaRefreshRunning,
                        firstTimeInstallation: userDetail.firstTimeInstallation
                    };
                    
                    const resultJson = JSON.stringify(completeUserDetail);
                    
                    authentication.notifySuccess(resultJson);
                } else {
                    const errorResult = JSON.stringify({
                        success: false,
                        errorType: 'authFailed',
                        errorMessage: 'No token received from Platform Identity'
                    });
                    authentication.notifySuccess(errorResult);
                }
            } else {
                const errorText = await tokenResponse.text();
                const errorResult = JSON.stringify({
                    success: false,
                    errorType: 'authFailed',
                    errorMessage: 'Failed to retrieve tokens from server'
                });
                authentication.notifySuccess(errorResult);
            }
        } catch (error) {
            console.error('PlatformIdentityCallback - Error:', error);
            const errorResult = JSON.stringify({
                success: false,
                errorType: 'unknown',
                errorMessage: error instanceof Error ? error.message : 'Error retrieving Platform Identity session'
            });
            authentication.notifySuccess(errorResult);
        }
    }     

    render() {
      return (
        <div>
            <h1>Platform Identity authentication complete.</h1>
        </div>
      );
    }
}

export default PlatformIdentityCallback;
